import styled from "styled-components";
import { Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import PaidIcon from "@mui/icons-material/Paid";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { theme } from "../../utils/globalStyles/colors";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const Name = styled(Typography)`
  font-weight: 800 !important;
  color: #333333;
  font-size: 20px !important;
  text-align: center;
  word-break: break-word;
  margin-top: 8px !important;
`;

export const Login = styled(Typography)`
  color: #888888;
  font-size: 14px !important;
  font-weight: 600 !important;
`;

export const InfoList = styled.div`
  width: 100%;
  margin: 16px 0 12px;
  padding: 4px 16px;
  border-radius: 14px;
  background-color: #f7f9fc;
  box-sizing: border-box;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:last-child {
    border-bottom: none;
  }
`;

export const Label = styled(Typography)`
  color: #777777;
  font-size: 14px !important;
  font-weight: 600 !important;
`;

export const Value = styled(Typography)`
  color: #333333;
  font-size: 15px !important;
  font-weight: 700 !important;
  text-align: right;
`;

export const CodeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: none;
  padding: 6px 0 6px 8px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 1px;
  color: ${theme.colors.base};
  cursor: pointer;
`;

export const CopyIcon = styled(ContentCopyIcon)`
  font-size: 16px !important;
  color: #999999;
`;

export const CopiedIcon = styled(CheckIcon)`
  font-size: 16px !important;
  color: #28a745;
`;

export const Coins = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${theme.colors.base};
  font-size: 16px !important;
  font-weight: 800 !important;
`;

export const CoinIcon = styled(PaidIcon)`
  font-size: 20px !important;
`;

const baseButton = `
  width: 100%;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
`;

export const PrimaryButton = styled.button`
  ${baseButton}
  border: none;
  background-color: ${theme.colors.base};
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(192, 90, 33, 0.25);
`;

export const EditIcon = styled(EditRoundedIcon)`
  font-size: 20px !important;
`;

export const LogoutButton = styled.button`
  ${baseButton}
  margin-top: 4px;
  border: none;
  background-color: transparent;
  color: #d93025;

  &:active {
    background-color: rgba(217, 48, 37, 0.08);
  }
`;

export const LogoutIcon = styled(LogoutRoundedIcon)`
  font-size: 20px !important;
`;
